<template>
  <div class="valueInput MGbottom5px" @click="$refs.dropdown.open = true;">
    <div class="label" :class="{'d-none': nameShort}">
      {{ name }}
    </div>
    <div class="select-wrapper">
      <v-select ref="dropdown" @close="handleClose" @open="handleOpen" :searchable="!noInput" :filter="search"
                class="select"
                label="text"
                v-model="selected"
                :options="options" @option:selected="removeLabel"/>
    </div>
  </div>
</template>

<script>
export default {
  name: "DropdownSelect",
  props: {
    options: Array,
    name: String,
    dataRef: String,
    initValue: [String, Boolean, Number],
    nameShort: String,
    noInput: Boolean,
    id: Number,
  },
  data: () => ({
    selected: null,
    span: null,

    idValue: null,
  }),
  created() {
    this.idValue = this.id;

    if(!this.id)
      this.idValue = 0;

    if (this.initValue !== null) {
      const selected = this.options.filter(option => option.value == this.initValue)[0];

      if(selected)
        this.selected = selected;

      // if (!this.selected) {
      //   const option = {text: `${this.initValue} EUR`, value: this.initValue};
      //   this.options.push(option);
      //   this.selected = option;
      // }
    }
  },
  mounted() {
    // console.log(this.idValue);

    (() => {
      document.getElementsByClassName("vs__open-indicator")[this.idValue].innerHTML = "<path d=\"M1 1L5.5 5.5L10 1\"  stroke-width=\"2\"/>";

      const el = document.getElementsByClassName("vs__search")[this.idValue];
      const nodeMap = el.attributes;
      const node = nodeMap.getNamedItem("type");
      node.value = "number";
      nodeMap.setNamedItem(node);

      this.handleClose();
    })();

    if (this.nameShort && !this.selected) {
      this.span = document.createElement("span");
      this.span.classList.add("vs__selected")
      this.span.innerHTML = this.nameShort;

      document.getElementsByClassName("vs__selected-options")[this.idValue].appendChild(this.span);
    }
  },
  methods: {
    search(options, search) {
      options.push({text: `${search} EUR`, value: search});

      return options;
    },
    handleClose() {
      const el = document.getElementsByClassName("vs__search")[this.idValue];
      el.style.display = "none";
    },
    handleOpen() {
      const el = document.getElementsByClassName("vs__search")[this.idValue];
      el.style.display = "block";
      el.focus();
    },
    removeLabel() {
      if (this.span) {
        this.span.remove();
        this.span = null;
      }
    }
  },
  watch: {
    selected(to) {
      if (to)
        this.$emit("select", {value: to.value, dataRef: this.dataRef});
    },
  },
}
</script>

<style lang="scss" scoped>
.freq {
  justify-content: end!important;

  @media (max-width: 576px) {
    justify-content: start!important;
  }
}

.select {
  height: 100%;
  width: 100%;
}
</style>